const console = (window && window.console) || {
  log: function(str) {
    window.console['_messages'].push(str);
  },
  _messages: [],
};

export default console;

